import React from "react";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import EnvelopeIcon from "@styles/all-images/icons/envelope-icon.svg";
import PhoneIcon from "@styles/all-images/icons/phone-icon.svg";
import EditIcon from "@styles/all-images/icons/edit-icon.svg";
import UserIcon from "@styles/all-images/icons/user.svg";
import HeaderComponent from "@components/common/Header/Header";
import { useNavigate } from "react-router-dom";

const MyAccount = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-bg-gray-50 tw-font-sans">
      {/* Header Section */}
      <HeaderComponent />
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />{" "}
              </a>
              <h1 className="tw-text-xl tw-ml-4 tw-font-semibold font-primary-color">
                My Account
              </h1>
            </div>
            <button
              onClick={() => navigate("/edit-my-account")}
              className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
            >
              Edit Details
            </button>
          </div>
        </div>
      </div>
      {/* Content Section */}
      <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-6 tw-px-8 tw-py-4 tw-mt-[157px]">
        {/* Left Profile Section */}
        <div className="lg:tw-fixed tw-top-[175px] lg:tw-z-50">
          <div className="tw-bg-[#FBF8FF] tw-rounded-[8px] tw-border-[#87C1DB] tw-border tw-w-full lg:tw-w-[260px] tw-p-8 tw-h-fit">
            {/* Profile Image */}
            <div className="tw-mb-4 tw-flex tw-items-center tw-justify-center">
              <div className="tw-border tw-border-[#E9EAEB] tw-bg-white tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-items-center tw-justify-center tw-relative tw-z-0">
                <img src={UserIcon} alt="Profile" className="tw-w-12 tw-h-12" />
                <button className="tw-absolute tw-bottom-0 tw-right-0 tw-bg-blue-500 tw-text-white tw-p-2 tw-rounded-full tw-z-50">
                  <img src={EditIcon} alt="Edit" className="tw-w-4 tw-h-4" />
                </button>
              </div>
            </div>
            <div className="tw-flex tw-items-center tw-justify-between tw-flex-col">
              {/* User Info */}
              <h2 className="tw-text-lg tw-font-semibold font-primary font-default-primary-color">
                John Doe
              </h2>
              <p className="tw-flex tw-items-center font-primary-color tw-text-sm tw-mt-2">
                <img
                  src={EnvelopeIcon}
                  alt="Envelope"
                  className="tw-mr-2 tw-w-4 tw-h-4"
                />
                johndoe@gmail.com
              </p>
              <p className="tw-flex tw-items-center font-primary-color tw-text-sm tw-mt-1">
                <img
                  src={PhoneIcon}
                  alt="Phone"
                  className="tw-mr-2 tw-w-4 tw-h-4"
                />
                +27 211 23 45 67
              </p>
            </div>
          </div>
        </div>
        {/* Right Details Section */}
        <div className="tw-w-full lg:tw-w-full tw-ml-0 lg:tw-ml-[280px]">
          <div className="tw-bg-white custom-card">
            {/* Company Details */}
            <div>
              <div className="custom-card-header">
                <h3 className="font-size-base tw-font-semibold font-primary-color">
                  Company Details
                </h3>
              </div>
              <div className="custom-card-body">
                <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Registered Company Name
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      ZuluTech Innovations (Pty) Ltd
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Trading As
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      ZuluTech Solutions
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Commodity Type
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      Software Solutions
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tw-bg-white custom-card tw-my-4">
            {/* Administrative Details */}
            <div>
              <div className="custom-card-header">
                <h3 className="font-size-base tw-font-semibold font-primary-color">
                  Administrative Details
                </h3>
              </div>
              <div className="custom-card-body">
                <div className="tw-grid tw-grid-cols-2 tw-gap-6">
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Name
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      Sibongile Mthembu
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Primary Email Address
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      sibongilemthembu@gmail.com
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Primary Contact Number
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      +27 65 890 1234
                    </p>
                  </div>
                  <div>
                    <p className="tw-text-sm font-gray-color tw-font-medium">
                      Role/ Designation
                    </p>
                    <p className="tw-font-medium font-primary-color tw-mt-1">
                      Office Manager
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
